module.exports = __webpack_public_path__ + "img/medidores.7797d191.svg";